export const STR = {
  ar: {
    nav: { home: "الرئيسية", services: "خدماتنا", projects: "مشاريعنا", about: "من نحن", partners: "شركاؤنا", contact: "اتصل بنا", cta: "اطلب عرض سعر" },
    hero: {
      badge: "شركة فكرة بغداد",
      lines: ["نبني العراق", "بشغف الهندسة،", "ونُضيء مستقبلها بطاقة الشمس"],
      subtitle: "شركة فكرة بغداد — تأسست عام 2018، مقاول متعدد التخصصات ينفذ مشاريع البنى التحتية الحيوية من بغداد إلى كركوك، بأسطول آليات ذاتي وكادر نخبوي وشهادات ISO العالمية.",
      ctaContact: "ابدأ مشروعك معنا",
      ctaProjects: "شاهد مشاريعنا",
      ctaProfile: "حمّل بروفايل الشركة",
      metrics: [
        { value: 200, suffix: "+", label: "كادر مهني معتمد" },
        { value: 50, suffix: "+", label: "مليار د.ع عقود كبرى" },
        { value: 7, suffix: "", label: "شركات تخصصية تابعة" },
      ],
      scroll: "انتقل للأسفل",
      imgAlt: "أعمال صب الكونكريت الليلية في مشاريع فكرة بغداد",
    },
    marquee: [
      "المقاولات العامة والإنشاءات الكبرى",
      "مشاريع الطاقة الشمسية المستدامة",
      "محطات التوليد والتوزيع",
      "إعادة إعمار وتطوير البنية التحتية",
      "فكرة بغداد — الهندسة والاستدامة",
    ],
    services: {
      index: "٠١",
      eyebrow: "خدماتنا",
      title: "حلول هندسية متكاملة — من الطرق والجسور إلى الطاقة",
      desc: "ستة تخصصات هندسية تحت سقف واحد، بأسطول آليات ثقيلة ذاتي التمويل وكادر نخبوي يضم أكثر من 200 مهني معتمد.",
      items: [
        { id: "roads", title: "الطرق السريعة والإكساء الإسفلتي الكونكريتي", desc: "تنفيذ أعمال الحفر والردم وتحضير الأساس وإكساء الشوارع الرئيسية بالإسفلت، ورفع متانة شبكات الطرق الحضرية وفق المعايير الوطنية للسلامة.", span: "lg:col-span-7" },
        { id: "bridges", title: "الجسور والتقاطعات والمجسرات", desc: "بناء الجسور العابرة بكمرات الكونكريت مسبق الصب عالية المقاومة، والتقاطعات متعددة المستويات التي تحل الاختناقات المرورية في المدن.", span: "lg:col-span-5" },
        { id: "water", title: "شبكات المياه ومياه الأمطار", desc: "خطوط نقل المياه الاستراتيجية، شبكات التوزيع الحضرية، محطات المعالجة الحديثة، ومنظومات تصريف مياه الأمطار ومكافحة الفيضانات.", span: "lg:col-span-5" },
        { id: "buildings", title: "الأبراج والمجمعات السكنية والتجارية", desc: "تطوير الأبراج السكنية الفاخرة والمجمعات التجارية الحديثة بمعمارية مستقبلية، من التصميم حتى التسليم بأرقى المواصفات.", span: "lg:col-span-7" },
        { id: "solar", title: "أنظمة الطاقة الشمسية والنظيفة", desc: "تصميم وتوريد وتثبيت منظومات الطاقة الشمسية للمنشآت الصناعية والحكومية والسكنية، دعماً لمسار الاستدامة وأمن الطاقة في العراق.", span: "lg:col-span-6" },
        { id: "mep", title: "الأعمال الكهروميكانيكية والاستشارات", desc: "تصميم وتنفيذ والإشراف على أنظمة MEP، وإدارة المشاريع PMO وضبط الجودة والسلامة HSE بشهادات ISO 9001 و14001 و45001.", span: "lg:col-span-6" },
      ],
    },
    projects: {
      index: "٠٢",
      eyebrow: "مشاريعنا",
      title: "سجلّ مشاريعنا البارزة",
      desc: "من جسور التازة إلى مجسرات كركوك وشبكات مياه بغداد وأبراج الجادرية — مشاريع حقيقية منفذة بعقود رسمية مع أمانة بغداد والجهات الحكومية.",
      filters: { all: "الكل", roads: "طرق وجسور", water: "بنى تحتية", buildings: "أبنية وتطوير" },
      storyLink: "قصة التنفيذ الكاملة",
    },
    detail: {
      back: "العودة إلى المشاريع",
      storyTitle: "قصة التنفيذ",
      highlightsTitle: "أبرز ملامح المشروع",
      galleryTitle: "من موقع المشروع",
      ctaTitle: "لديك مشروع مشابه؟",
      ctaText: "فريقنا الهندسي جاهز لدراسة مشروعك وتقديم عرض فني ومالي متكامل.",
      ctaBtn: "تواصل معنا الآن",
    },
    about: {
      index: "٠٣",
      eyebrow: "من نحن",
      title: "فكرة بغداد — من التأسيس إلى عصر المشاريع الكبرى",
      desc: "تأسست عام 2018 ورسّخت مكانتها كمقاول رائد متعدد التخصصات في المشاريع التنموية الحيوية، من مقرها في بغداد وعملياتها في كركوك، برأسمال ملياري دينار ودرجة «ممتاز» في الغرفة التجارية.",
      chapters: [
        { number: "01", headline: "رؤيتنا", text: "أن نكون المجموعة الهندسية المتكاملة الأكثر تميزاً وموثوقية في العراق، وأن نضع المعايير الوطنية لتنفيذ البنى التحتية الكبرى وقيادة ممارسات البناء المستدام." },
        { number: "02", headline: "رسالتنا", text: "تقديم بنية تحتية وصروح صحية وشبكات مدنية بمواصفات عالمية، عبر تحالف سبع شركات تخصصية وأسطول آليات ضخم وكادر نخبوي من 200 موظف، مع ضمان الحوكمة المالية المطلقة والسلامة المهنية." },
        { number: "03", headline: "قيمنا", text: "التميز الهندسي، النزاهة التي لا تلين، السرعة والموثوقية في التسليم قبل المواعيد، والسلامة أولاً في كل موقع عمل — دقة في التنفيذ، ونزاهة في الشراكة." },
      ],
      badges: ["ISO 9001:2015 الجودة", "ISO 14001:2015 البيئة", "ISO 45001:2018 السلامة", "تصنيف رابع — أعمال مدنية", "تصنيف خامس — MEP", "مسجّلون لدى وزارة التخطيط"],
      chairmanEyebrow: "كلمة رئيس مجلس الإدارة والمدير المفوض",
      chairmanTitle: "نبني المستقبل بتميّز هندسي",
      chairmanText: "شركاءنا وعملاءنا الأعزاء — رسالتنا الواحدة هي إعادة تعريف البنية التحتية في العراق عبر جودة لا تتزعزع ودقة في التنفيذ. وبفضل خبرتنا الهندسية والتجارية الممتدة منذ عام 2018، ورأسمالنا التأسيسي البالغ مليار دينار عراقي، وتصنيفاتنا التجارية المرموقة، فإننا لا ننفذ المشاريع فحسب؛ بل تقدم فكرة بغداد معالم حضرية حيوية وبنية تحتية مدنية متقدمة وشبكات طرق استراتيجية وحلول توريد صناعية متخصصة في عموم المنطقة. ونبقى ملتزمين بأن نكون الشريك الأكثر موثوقية للتنمية المستدامة في العراق، دافعين النمو الاقتصادي طويل الأمد ومقدمين تميزاً لا يضاهى في جميع قطاعات عملنا.",
      chairmanName: "المهندس الاستشاري هيمن حسن عثمان",
      chairmanRole: "رئيس مجلس الإدارة والمدير المفوض — شركة فكرة بغداد للمقاولات",
      bannerLine1: "دقة في التنفيذ،",
      bannerAccent: "ونزاهة في الشراكة",
      bannerTag: "من مواقع عملنا — مباشرة من الميدان",
    },
    timeline: {
      index: "٠٤",
      eyebrow: "مسيرتنا",
      title: "من فكرة... إلى عصر المشاريع الكبرى",
      desc: "ثمان سنوات من النمو المستمر — كل محطة في هذه المسيرة صاغت قدرتنا على تنفيذ مشاريع اليوم الكبرى.",
      milestones: [
        { year: "2018", title: "التأسيس — الانطلاقة العالمية", text: "تأسست فكرة بغداد برؤية تجارة وتوريد عابرة للقارات، تربط الأسواق الدولية في أمريكا وتركيا بمشاريع البنية التحتية الحضرية الكبرى في العراق." },
        { year: "2021", title: "التنويع الهيكلي", text: "توسعنا في الأعمال الكهروميكانيكية الثقيلة MEP وقطاعات شبكات المياه المعقدة، وأبرمنا شراكات استراتيجية مع مديريات الدولة الرئيسية." },
        { year: "2026", title: "عصر المشاريع الكبرى", text: "أصبحنا شركة مصنّفة بأعلى الدرجات، ندير أسطول أصول بملايين الدولارات وأقساماً مؤسسية متنوعة، بعقود حكومية مؤمَّنة تتجاوز 50 مليار دينار عراقي." },
      ],
    },
    gallery: {
      index: "٠٥",
      eyebrow: "معرض ميداني",
      title: "من قلب مواقع العمل",
      desc: "لقطات حقيقية من مواقعنا — صب ليلي، مساحة، شدات، وتسليح. اضغط على أي صورة لعرضها بحجم كامل.",
      note: "صور موثقة من كوادرنا الميدانية — وسيُحدَّث هذا المعرض باستمرار مع كل مشروع جديد.",
    },
    partners: {
      index: "٠٦",
      eyebrow: "شركاؤنا",
      title: "شركات المجموعة وشركاء الاعتمادية",
      desc: "شركات تخصصية متكاملة بقوة تنفيذ موحدة، وثقة الجهات الحكومية — وعلى رأس عملائنا أمانة بغداد ودائرة مشاريعها.",
    },
    contact: {
      index: "٠٧",
      eyebrow: "اتصل بنا",
      title: "تواصل مع فريقنا الهندسي",
      desc: "لديك مشروع مقاولات أو خطة طاقة شمسية؟ أرسل لنا التفاصيل وسنعود إليك بدراسة أولية خلال يوم عمل واحد.",
      info: [
        { id: "address", label: "الفرع الرئيسي", value: "بغداد — حي المثنى، زيونة، م 710 / ز 295 / د 95" },
        { id: "branch2", label: "مقر الشركة", value: "كركوك — دور القضاة، خلف المحكمة الجديدة، دار رقم D2" },
        { id: "phone", label: "الهاتف", value: "+964 770 937 2007", dir: "ltr" },
        { id: "website", label: "الموقع", value: "www.fikratbaghdad.com", dir: "ltr" },
        { id: "email", label: "البريد الإلكتروني", value: "FikratBaghdad@gmail.com", dir: "ltr" },
      ],
      options: ["طرق وجسور ومجسرات", "بنى تحتية وشبكات مياه", "أبنية ومجمعات سكنية وتجارية", "أنظمة الطاقة الشمسية", "أعمال كهروميكانيكية MEP", "أخرى"],
      nameLabel: "الاسم الكامل",
      namePh: "مثال: أحمد الجبوري",
      phoneLabel: "رقم الهاتف",
      emailLabel: "البريد الإلكتروني",
      serviceLabel: "نوع الخدمة المطلوبة",
      messageLabel: "تفاصيل المشروع / الرسالة",
      messagePh: "اكتب لنا طبيعة مشروعك، موقعه، وأي تفاصيل تساعدنا على تقديم دراسة دقيقة...",
      send: "أرسل الرسالة",
      sending: "جارٍ الإرسال...",
      successTitle: "تم استلام رسالتك بنجاح",
      successDesc: "سيتواصل معك فريقنا الهندسي خلال 24 ساعة عمل.",
      errorTitle: "تعذر إرسال الرسالة",
      errorDesc: "يرجى التحقق من البيانات والمحاولة مرة أخرى.",
    },
    footer: {
      about: "شركة فكرة بغداد للمقاولات والتجارة والاستثمارات الصناعية محدودة المسؤولية — تأسست عام 2018، مقاول عراقي متعدد التخصصات في البنى التحتية الكبرى من بغداد إلى كركوك.",
      quickTitle: "روابط سريعة",
      contactTitle: "تواصل معنا",
      branch1: "الفرع الرئيسي: بغداد — حي المثنى، زيونة، م 710 / ز 295 / د 95",
      branch2: "مقر الشركة: كركوك — دور القضاة، خلف المحكمة الجديدة، دار D2",
      profile: "تحميل بروفايل الشركة (PDF)",
      rights: "© 2026 فكرة بغداد للمقاولات العامة والطاقة النظيفة — جميع الحقوق محفوظة",
      admin: "دخول المدير",
    },
  },
  en: {
    nav: { home: "Home", services: "Services", projects: "Projects", about: "About Us", partners: "Partners", contact: "Contact", cta: "Request a Quote" },
    hero: {
      badge: "Fikrat Baghdad Company",
      lines: ["We build Iraq", "with engineering passion,", "and light its future with solar power"],
      subtitle: "Fikrat Baghdad Company — founded in 2018, a multi-disciplinary contractor delivering vital infrastructure projects from Baghdad to Kirkuk, with a self-owned heavy fleet, an elite workforce and world-class ISO certifications.",
      ctaContact: "Start Your Project",
      ctaProjects: "See Our Projects",
      ctaProfile: "Download Company Profile",
      metrics: [
        { value: 200, suffix: "+", label: "Certified professionals" },
        { value: 50, suffix: "+", label: "Billion IQD in major contracts" },
        { value: 7, suffix: "", label: "Specialized subsidiaries" },
      ],
      scroll: "Scroll down",
      imgAlt: "Night concrete pouring at Fikrat Baghdad project sites",
    },
    marquee: [
      "General contracting & major construction",
      "Sustainable solar energy projects",
      "Generation & distribution plants",
      "Infrastructure rebuilding & development",
      "Fikrat Baghdad — Engineering & Sustainability",
    ],
    services: {
      index: "01",
      eyebrow: "Our Services",
      title: "Integrated Engineering Solutions — From Roads & Bridges to Energy",
      desc: "Six engineering disciplines under one roof, powered by a self-financed heavy machinery fleet and an elite workforce of 200+ certified professionals.",
      items: [
        { id: "roads", title: "Highways & Asphalt-Concrete Paving", desc: "Excavation, backfilling, sub-base preparation and asphalt paving of arterial roads, raising the durability of urban road networks to national safety standards.", span: "lg:col-span-7" },
        { id: "bridges", title: "Bridges, Interchanges & Flyovers", desc: "Building transit bridges with high-resistance precast concrete girders and multi-level interchanges that solve urban traffic congestion.", span: "lg:col-span-5" },
        { id: "water", title: "Water & Stormwater Networks", desc: "Strategic water transmission lines, urban distribution networks, modern treatment plants, and stormwater drainage & flood-control systems.", span: "lg:col-span-5" },
        { id: "buildings", title: "Residential & Commercial Towers", desc: "Developing premium residential towers and modern commercial complexes with futuristic architecture — from design to handover at the finest specifications.", span: "lg:col-span-7" },
        { id: "solar", title: "Solar & Clean Energy Systems", desc: "Design, supply and installation of solar power systems for industrial, governmental and residential facilities — supporting Iraq's sustainability and energy security.", span: "lg:col-span-6" },
        { id: "mep", title: "Electromechanical Works & Consulting", desc: "Design, execution and supervision of MEP systems, PMO project management, and QA/HSE control certified to ISO 9001, 14001 and 45001.", span: "lg:col-span-6" },
      ],
    },
    projects: {
      index: "02",
      eyebrow: "Our Projects",
      title: "Our Landmark Project Portfolio",
      desc: "From the Taza bridges to Kirkuk's flyovers, Baghdad's water networks and the Al-Jadriyah towers — real projects delivered under official contracts with Amanat Baghdad and government bodies.",
      filters: { all: "All", roads: "Roads & Bridges", water: "Infrastructure", buildings: "Buildings & Development" },
      storyLink: "Full execution story",
    },
    detail: {
      back: "Back to Projects",
      storyTitle: "Execution Story",
      highlightsTitle: "Project Highlights",
      galleryTitle: "From the Project Site",
      ctaTitle: "Have a similar project?",
      ctaText: "Our engineering team is ready to study your project and deliver a complete technical and financial proposal.",
      ctaBtn: "Contact Us Now",
    },
    about: {
      index: "03",
      eyebrow: "About Us",
      title: "Fikrat Baghdad — From Foundation to the Mega-Project Era",
      desc: "Founded in 2018, the company has cemented its position as a leading multi-disciplinary contractor in vital development projects — headquartered in Baghdad with operations in Kirkuk, backed by 2 billion IQD capital and an 'Excellent' Chamber of Commerce grade.",
      chapters: [
        { number: "01", headline: "Our Vision", text: "To be Iraq's most distinguished and trusted integrated engineering group, setting national benchmarks for mega-infrastructure delivery and leading sustainable construction practices." },
        { number: "02", headline: "Our Mission", text: "Delivering world-class infrastructure, healthcare facilities and civil networks through an alliance of seven specialized companies, a massive machinery fleet and an elite 200-strong workforce — with absolute financial governance and occupational safety." },
        { number: "03", headline: "Our Values", text: "Engineering excellence, unwavering integrity, speed and reliability in early delivery, and safety first at every work site — precision in execution, integrity in partnership." },
      ],
      badges: ["ISO 9001:2015 Quality", "ISO 14001:2015 Environment", "ISO 45001:2018 Safety", "Grade 4 — Civil Works", "Grade 5 — MEP", "Registered with the Ministry of Planning"],
      chairmanEyebrow: "A Word from the Chairman & Managing Director",
      chairmanTitle: "Building the Future with Engineering Excellence",
      chairmanText: "Dear partners and clients — our single mission is to redefine Iraq's infrastructure through unwavering quality and precision execution. Backed by engineering and commercial expertise established since 2018, a foundational capital of 1 billion IQD, and esteemed trade classifications, we do not merely execute projects; Fikrat Baghdad delivers vital urban milestones, advanced civil infrastructure, strategic road networks and specialized industrial supply solutions across the region. We remain profoundly committed to being Iraq's most trusted partner in sustainable development, driving long-term economic growth and delivering unparalleled excellence across all our operations.",
      chairmanName: "Consultant Engineer Hemn Hassan Othman",
      chairmanRole: "Chairman & Managing Director — Fikrat Baghdad Contracting Co.",
      bannerLine1: "Precision in execution,",
      bannerAccent: "integrity in partnership",
      bannerTag: "From our work sites — straight from the field",
    },
    timeline: {
      index: "04",
      eyebrow: "Our Journey",
      title: "From an Idea... to the Mega-Project Era",
      desc: "Eight years of continuous growth — every milestone in this journey shaped our capacity to deliver today's mega-projects.",
      milestones: [
        { year: "2018", title: "Foundation — The Global Launch", text: "Fikrat Baghdad was founded with a vision of transcontinental trading and supply, linking international markets in America and Turkey with Iraq's major urban infrastructure projects." },
        { year: "2021", title: "Structural Diversification", text: "We expanded into heavy electromechanical (MEP) works and complex water network sectors, and signed strategic partnerships with key state directorates." },
        { year: "2026", title: "The Mega-Project Era", text: "We became a company classified at the highest grades, managing a multi-million-dollar asset fleet and diverse corporate divisions, with secured government contracts exceeding 50 billion IQD." },
      ],
    },
    gallery: {
      index: "05",
      eyebrow: "Field Gallery",
      title: "From the Heart of Our Work Sites",
      desc: "Real shots from our sites — night pouring, surveying, formwork and rebar. Click any photo to view it in full size.",
      note: "Documented photos by our field crews — this gallery is continuously updated with every new project.",
    },
    partners: {
      index: "06",
      eyebrow: "Our Partners",
      title: "Group Companies & Partners of Trust",
      desc: "Integrated specialized companies with unified execution power, and the trust of government bodies — led by our client Amanat Baghdad and its projects department.",
    },
    contact: {
      index: "07",
      eyebrow: "Contact Us",
      title: "Talk to Our Engineering Team",
      desc: "Have a contracting project or a solar energy plan? Send us the details and we will get back to you with an initial study within one business day.",
      info: [
        { id: "address", label: "Main Branch", value: "Baghdad — Al-Muthanna, Zayouna, Dist. 710 / Alley 295 / House 95" },
        { id: "branch2", label: "Headquarters", value: "Kirkuk — Judges' District, behind the New Court, House D2" },
        { id: "phone", label: "Phone", value: "+964 770 937 2007", dir: "ltr" },
        { id: "website", label: "Website", value: "www.fikratbaghdad.com", dir: "ltr" },
        { id: "email", label: "Email", value: "FikratBaghdad@gmail.com", dir: "ltr" },
      ],
      options: ["Roads, bridges & flyovers", "Infrastructure & water networks", "Residential & commercial buildings", "Solar energy systems", "Electromechanical (MEP) works", "Other"],
      nameLabel: "Full Name",
      namePh: "e.g. Ahmed Al-Jubouri",
      phoneLabel: "Phone Number",
      emailLabel: "Email Address",
      serviceLabel: "Required Service",
      messageLabel: "Project Details / Message",
      messagePh: "Tell us about your project, its location, and any details that help us prepare an accurate study...",
      send: "Send Message",
      sending: "Sending...",
      successTitle: "Your message was received",
      successDesc: "Our engineering team will contact you within 24 business hours.",
      errorTitle: "Message could not be sent",
      errorDesc: "Please check the details and try again.",
    },
    footer: {
      about: "Fikrat Baghdad for General Contracting, Trading and Industrial Investments LLC — founded in 2018, an Iraqi multi-disciplinary contractor in mega infrastructure, from Baghdad to Kirkuk.",
      quickTitle: "Quick Links",
      contactTitle: "Get in Touch",
      branch1: "Main Branch: Baghdad — Al-Muthanna, Zayouna, 710/295/95",
      branch2: "Headquarters: Kirkuk — Judges' District, House D2",
      profile: "Download Company Profile (PDF)",
      rights: "© 2026 Fikrat Baghdad General Contracting & Clean Energy — All rights reserved",
      admin: "Admin Login",
    },
  },
};

export const GALLERY_EN = {
  "أعمال الصب الليلية — أبراج الجادرية": "Night concrete pouring — Al-Jadriyah Towers",
  "الموديل الهندسي — أبراج الجادرية": "Engineering model — Al-Jadriyah Towers",
  "أعمال المساحة الليلية بجهاز المحطة الشاملة": "Night surveying with total station",
  "الشدات السقفية SLABDECK قيد التركيب": "SLABDECK slab formwork installation",
  "تسليح السقوف فوق سماء المدينة": "Slab rebar works above the city skyline",
  "الرندر الجوي لمخطط مدينة جواهري": "Aerial render of the Jawahiry City master plan",
  "الرندر الهندسي للمجسر متعدد المستويات": "Engineering render of the multi-level flyover",
  "أعمال مد القسائم العملاقة في موقع المشروع": "Laying giant pipelines at the project site",
  "فريشة الأسفلت والهراسات أثناء التنفيذ": "Asphalt paver and rollers during execution",
  "الرندر المعماري للبرجين التوأمين": "Architectural render of the twin towers",
  "الموديل الهندسي التفصيلي للمشروع": "Detailed engineering model of the project",
  "أعمال الصب الليلية فوق سماء بغداد": "Night pouring above Baghdad's skyline",
  "الشدات السقفية SLABDECK قيد التركيب": "SLABDECK slab formwork installation",
  "أعمال المساحة الليلية بجهاز المحطة الشاملة": "Night surveying with total station",
  "واجهة المول التجاري بأقواسه المعمارية": "The mall facade with its grand arches",
};

export const PROJECT_EN = {
  "مدينة جواهري": {
    title: "Jawahiry City",
    categoryLabel: "Roads & Bridges",
    location: "Al-Taza District",
    client: "Fikrat Baghdad Development",
    excerpt: "The integrated Jawahiry City project — heavy civil engineering and infrastructure for a strategic trade corridor linking vital industrial sectors across Al-Taza, with precast concrete girders and reinforced supports for heavy cargo flow.",
    story: [
      "Jawahiry City stands as one of Fikrat Baghdad's most prominent heavy civil engineering works — an integrated urban complex designed and built as a strategic trade corridor linking vital industrial sectors across Al-Taza, with a modern master plan balancing residential blocks, green spaces and central plazas.",
      "Execution relied on high-resistance precast concrete girders and reinforced structural supports, allowing the transit bridge to efficiently handle heavy cargo flows and strengthen regional trade corridors — with full commitment to national safety standards at every construction stage.",
    ],
    highlights: ["High-resistance precast concrete girders", "Reinforced structural piling supports", "Designed for heavy cargo flows", "Integrated master plan with green spaces"],
  },
  "تقاطع ومجسر طريق حولي": {
    title: "Tariq Hawli Interchange & Flyover",
    categoryLabel: "Roads & Bridges",
    location: "Kirkuk — towards the University",
    client: "In partnership with Taseli Co.",
    excerpt: "A flyover linking Airport Road towards the University — delivered by Fikrat Baghdad in partnership with Taseli to radically resolve traffic congestion, with advanced elevated flyovers and streamlined entry/exit ramps.",
    story: [
      "A vital transport development project delivered by Taseli and Fikrat Baghdad to radically resolve traffic congestion at the Tariq Hawli junction in Kirkuk — one of the busiest axes towards the University and Airport Road.",
      "The project features advanced multi-level elevated flyovers and streamlined entry and exit ramps engineered to organize traffic flow and enhance road safety, with advanced urban mobility solutions that cut daily commute times for thousands of vehicles.",
    ],
    highlights: ["Multi-level interchange with elevated flyovers", "Streamlined entry & exit ramps", "Radical congestion relief at Tariq Hawli", "Enhanced urban road safety"],
  },
  "شبكة مياه الأمطار الاستراتيجية ومكافحة الفيضانات": {
    title: "Strategic Stormwater Network & Flood Control",
    categoryLabel: "Infrastructure",
    location: "Baghdad — Al-Tarbiyah & Al-Maamel Sts, Boub Al-Sham",
    client: "Amanat Baghdad — Official Contract",
    excerpt: "A massive stormwater drainage project under an official contract with Amanat Baghdad, covering Al-Tarbiyah Street and Al-Maamel Street (District 361, Boub Al-Sham) — a cornerstone of the capital's hydraulic infrastructure.",
    story: [
      "Through its executive arm Fikrat Baghdad, and under an official contract with Amanat Baghdad, the group successfully delivered stormwater networks and drainage works in vital areas of the capital — led by Al-Tarbiyah Street and Al-Maamel Street (District 361, Boub Al-Sham).",
      "This project is a cornerstone in developing the capital's hydraulic infrastructure — from laying giant pipelines with heavy cranes to modern sewage management — protecting Baghdad's neighborhoods from seasonal flooding and raising drainage readiness for decades to come.",
    ],
    highlights: ["Official contract with Amanat Baghdad", "Giant pipelines laid by heavy cranes", "Al-Tarbiyah & Al-Maamel — District 361", "Protecting the capital from seasonal floods"],
  },
  "إكساء وتأهيل شارع حمزة": {
    title: "Al-Hamza Street Paving & Rehabilitation",
    categoryLabel: "Roads & Bridges",
    location: "Baghdad",
    client: "Amanat Baghdad Projects Dept.",
    excerpt: "Sub-base, paving and asphalt overlay works for the capital's main streets including Al-Hamza Street over 18,000+ m², using the latest mechanized paving machinery in cooperation with Amanat Baghdad's Projects Department.",
    story: [
      "In close cooperation with Amanat Baghdad's Projects Department, Fikrat Baghdad delivered an integrated strategic project covering sub-base preparation, paving and asphalt overlay of the capital's main streets — including Al-Hamza Street over an area exceeding 18,000 square meters.",
      "The project was executed with a modern mechanized fleet of asphalt pavers and heavy rollers — from earthworks and base preparation to final surfacing — ensuring durable urban roads raised to national safety standards and smoother traffic across the capital.",
    ],
    highlights: ["18,000+ m² of asphalt overlay", "Fully modern mechanized paving fleet", "Integrated earthworks & base preparation", "With Amanat Baghdad Projects Dept."],
  },
  "أبراج الجادرية السكنية": {
    title: "Al-Jadriyah Residential Towers",
    categoryLabel: "Buildings & Development",
    location: "Baghdad — Al-Jadriyah",
    client: "Fikrat Baghdad Development",
    excerpt: "Two identical residential towers in a futuristic architectural style in the capital's finest district — curved glass facades, sustainable green balconies, a central commercial plaza and panoramic city views.",
    story: [
      "Al-Jadriyah Residential Towers is a landmark in Baghdad's premium real-estate development sector — two identical towers with a futuristic design featuring continuous glass facades and wave-like white structures that give the building an unforgettable architectural identity.",
      "The project sets new standards for upscale urban living: green surfaces through hanging gardens and sustainable balconies, panoramic city views, central commercial plazas, and private waterfront access — with integrated leisure amenities and water promenades reflecting the complex's luxurious character. The site photos below document actual execution stages, from formwork and rebar to night pouring.",
    ],
    highlights: ["Twin towers with curved glass facades", "Hanging gardens & sustainable balconies", "Central commercial plaza & waterfront", "Panoramic views over Baghdad"],
  },
  "مول تجاري فاخر وجادة تسوق": {
    title: "Premium Mall & Retail Boulevard",
    categoryLabel: "Buildings & Development",
    location: "Iraq",
    client: "Fikrat Baghdad Development",
    excerpt: "A premium mall and retail boulevard — modern architecture blending curved geometries and grand arches, designed to host the world's leading luxury brands.",
    story: [
      "This project embodies modern commercial architecture and elite shopping-center development — a prominent commercial development that ingeniously blends curved geometries with grand futuristic arches, becoming a landmark that draws visitors from across the region.",
      "Spanning heavy structural engineering to premium aesthetic finishes, the project was designed specifically to host leading international luxury brands — cementing its status as the region's premier destination for upscale retail and modern urban commerce.",
    ],
    highlights: ["Grand arches with futuristic character", "From heavy structures to premium finishes", "Designed for world-leading brands", "A regional upscale retail destination"],
  },
};
